import { useEffect, useState } from "react";
import { RiLoader4Line } from "react-icons/ri";

function YesNo({ displayType, pd, yesCB, noCB }) {

    const [noClicked, setNoClicked] = useState(false);

    useEffect(() => {
        setNoClicked(false);
    }, [pd?.id]);

    return (
        <div>
            <div className='yn-y' onClick={() => {
                yesCB()
            }}><h5>Y</h5></div>

            <div className={`yn-n ${displayType == -1 && "yn-n-disable"}`} onClick={() => {
                if (displayType != -1) {
                    noCB();
                    setNoClicked(true);
                }
            }}>
                {!noClicked && <h5>N</h5>}
                {noClicked && <RiLoader4Line className="custom-loader-icon rotate" />}
            </div>
        </div>
    );
}

export default YesNo;